<template>
    <div class="admin-edit">
        <div class="edit-grid">
            <!-- 左：表单 -->
            <div class="a-card edit-main">
                <div class="a-toolbar">
                    <strong style="font-size: 13.5px">{{ form.id ? '编辑页面 #' + form.id : '新建页面' }}</strong>
                    <span class="grow"></span>
                    <span class="save-hint" v-if="savedAt">已保存 {{ savedAt }}</span>
                </div>

                <div class="edit-form">
                    <div class="a-form-row">
                        <label class="f-label">页面标题<span class="req">*</span></label>
                        <input class="a-input" v-model="form.title" placeholder="例如：入目无他人，四下皆是你" />
                    </div>

                    <div class="row-2">
                        <div class="a-form-row">
                            <label class="f-label">
                                路由标识
                                <span class="f-tip">前台地址 #/p/{{ form.code || 'xxx' }}</span>
                            </label>
                            <input class="a-input" v-model="form.code" placeholder="留空自动生成，如 we / last" />
                        </div>
                        <div class="a-form-row">
                            <label class="f-label">渲染主题</label>
                            <select class="a-select" v-model="form.theme">
                                <option v-for="t in themes" :key="t.value" :value="t.value">{{ t.label }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row-2">
                        <div class="a-form-row">
                            <label class="f-label">副标题<span class="f-tip">信头/标题下方的小字</span></label>
                            <input class="a-input" v-model="form.subtitle" placeholder="可留空" />
                        </div>
                        <div class="a-form-row">
                            <label class="f-label">主体称谓<span class="f-tip">红玫瑰主题正中显示</span></label>
                            <input class="a-input" v-model="form.nameText" placeholder="例如：小 张 玲" />
                        </div>
                    </div>

                    <div class="a-form-row">
                        <label class="f-label">列表摘要<span class="f-tip">显示在「信箱」列表卡片上</span></label>
                        <textarea class="a-input" v-model="form.summary" placeholder="一两句话介绍这封信"></textarea>
                    </div>

                    <div class="row-2">
                        <div class="a-form-row">
                            <label class="f-label">列表角标</label>
                            <input class="a-input" v-model="form.tag" placeholder="例如：🌹 红玫瑰" />
                        </div>
                        <div class="a-form-row">
                            <label class="f-label">页面日期<span class="f-tip">信头显示的日期</span></label>
                            <input class="a-input" v-model="form.date" placeholder="例如：2026年3月1日" />
                        </div>
                    </div>

                    <!-- 诗句 -->
                    <div class="a-form-row">
                        <label class="f-label">
                            诗句
                            <span class="f-tip">每行一句，红玫瑰主题会逐句居中展示</span>
                        </label>
                        <div class="list-editor">
                            <div class="le-item" v-for="(v, i) in form.verses" :key="'v' + i">
                                <span class="le-idx">{{ i + 1 }}</span>
                                <input class="a-input" v-model="form.verses[i]" placeholder="例：只愿君心似我心，定不负相思意。" />
                                <button class="a-btn mini danger" @click="removeItem(form.verses, i)">×</button>
                            </div>
                            <button class="a-btn mini" @click="form.verses.push('')">＋ 加一句</button>
                        </div>
                    </div>

                    <div class="a-form-row">
                        <label class="f-label">诗句出处<span class="f-tip">集句时标注，可留空</span></label>
                        <input class="a-input" v-model="form.verseFrom" placeholder="例如：李之仪《卜算子》" />
                    </div>

                    <!-- 段落 -->
                    <div class="a-form-row">
                        <label class="f-label">
                            正文段落
                            <span class="f-tip">共 {{ paraCount }} 段 · 每段一个输入框</span>
                        </label>
                        <div class="list-editor">
                            <div class="le-item para" v-for="(p, i) in form.paragraphs" :key="'p' + i">
                                <span class="le-idx">{{ i + 1 }}</span>
                                <textarea class="a-input" v-model="form.paragraphs[i]" placeholder="这一段想说的话…"></textarea>
                                <div class="le-ops">
                                    <button class="a-btn mini" :disabled="i === 0" @click="move(form.paragraphs, i, -1)">↑</button>
                                    <button
                                        class="a-btn mini"
                                        :disabled="i === form.paragraphs.length - 1"
                                        @click="move(form.paragraphs, i, 1)"
                                    >↓</button>
                                    <button class="a-btn mini danger" @click="removeItem(form.paragraphs, i)">×</button>
                                </div>
                            </div>
                            <button class="a-btn mini" @click="form.paragraphs.push('')">＋ 加一段</button>
                        </div>
                    </div>

                    <div class="row-2">
                        <div class="a-form-row">
                            <label class="f-label">落款署名</label>
                            <input class="a-input" v-model="form.sign" placeholder="例如：大大大混蛋-----玲" />
                        </div>
                        <div class="a-form-row">
                            <label class="f-label">落款日期</label>
                            <input class="a-input" v-model="form.signDate" placeholder="例如：2026年3月10日" />
                        </div>
                    </div>

                    <div class="row-3">
                        <div class="a-form-row">
                            <label class="f-label">状态</label>
                            <select class="a-select" v-model.number="form.status">
                                <option :value="0">草稿（前台不可见）</option>
                                <option :value="1">已发布</option>
                                <option :value="2">已下线</option>
                            </select>
                        </div>
                        <div class="a-form-row">
                            <label class="f-label">排序<span class="f-tip">越大越靠前</span></label>
                            <input class="a-input" type="number" v-model.number="form.sort" />
                        </div>
                        <div class="a-form-row">
                            <label class="f-label">备注<span class="f-tip">仅后台可见</span></label>
                            <input class="a-input" v-model="form.remark" />
                        </div>
                    </div>

                    <!-- 操作 -->
                    <div class="edit-actions">
                        <button class="a-btn primary" :disabled="saving" @click="save(false)">
                            {{ saving ? '保存中…' : '保存' }}
                        </button>
                        <button class="a-btn primary" :disabled="saving" @click="save(true)">
                            保存并发布
                        </button>
                        <button class="a-btn" @click="back">返回列表</button>
                        <span class="grow"></span>
                        <button class="a-btn" :disabled="!form.id" @click="preview">预览效果</button>
                    </div>
                </div>
            </div>

            <!-- 右：速览 -->
            <div class="a-card edit-side">
                <div class="a-toolbar"><strong style="font-size: 13.5px">实时速览</strong></div>
                <div class="mini-preview" :class="form.theme">
                    <div class="mp-name" v-if="form.nameText">{{ form.nameText }}</div>
                    <div class="mp-title">{{ form.title || '（页面标题）' }}</div>
                    <div class="mp-sub" v-if="form.subtitle">{{ form.subtitle }}</div>
                    <div class="mp-date" v-if="form.date">{{ form.date }}</div>
                    <div class="mp-verse" v-for="(v, i) in verseList" :key="'mv' + i">{{ v }}</div>
                    <div class="mp-para" v-for="(p, i) in paraList" :key="'mp' + i">{{ p }}</div>
                    <div class="mp-sign" v-if="form.sign">{{ form.sign }}</div>
                    <div class="mp-count">正文 {{ paraCount }} 段</div>
                </div>
            </div>
        </div>

        <transition name="fade">
            <div v-if="toast" class="a-toast" :class="toast.type">{{ toast.text }}</div>
        </transition>
    </div>
</template>

<script>
import { adminApi } from './api';

function blankForm() {
    return {
        id: 0,
        code: '',
        title: '',
        subtitle: '',
        nameText: '',
        summary: '',
        tag: '',
        theme: 'letter',
        verses: [],
        verseFrom: '',
        paragraphs: [''],
        sign: '',
        signDate: '',
        date: '',
        status: 0,
        sort: 0,
        remark: ''
    };
}

export default {
    name: 'AdminEdit',
    data() {
        return {
            form: blankForm(),
            themes: [
                { value: 'letter', label: '信纸（米色卡片 + 居中标题）' },
                { value: 'rose', label: '红玫瑰（深红背景 + 花瓣 + 诗句）' },
                { value: 'plain', label: '简约（白底素排）' }
            ],
            saving: false,
            savedAt: '',
            toast: null,
            toastTimer: null
        };
    },
    computed: {
        paraCount() {
            return (this.form.paragraphs || []).filter(p => p && p.trim()).length;
        },
        paraList() {
            return (this.form.paragraphs || []).filter(p => p && p.trim());
        },
        verseList() {
            return (this.form.verses || []).filter(v => v && v.trim());
        }
    },
    created() {
        this.loadThemes();
        const id = this.$route.query.id;
        if (id) {
            this.load(id);
        }
    },
    methods: {
        loadThemes() {
            adminApi
                .themes()
                .then(data => {
                    if (data && data.items && data.items.length) {
                        this.themes = data.items;
                    }
                })
                .catch(() => {});
        },
        load(id) {
            adminApi
                .page(id, '')
                .then(d => {
                    this.form = {
                        id: d.id,
                        code: d.code,
                        title: d.title,
                        subtitle: d.subtitle,
                        nameText: d.nameText,
                        summary: d.summary,
                        tag: d.tag,
                        theme: d.theme || 'letter',
                        verses: (d.verses || []).slice(),
                        verseFrom: d.verseFrom,
                        paragraphs: (d.paragraphs || []).length ? d.paragraphs.slice() : [''],
                        sign: d.sign,
                        signDate: d.signDate,
                        date: d.date,
                        status: d.status,
                        sort: d.sort,
                        remark: d.remark
                    };
                })
                .catch(err => this.notify(err.message, 'err'));
        },
        notify(text, type) {
            this.toast = { text: text, type: type || 'ok' };
            clearTimeout(this.toastTimer);
            this.toastTimer = setTimeout(() => {
                this.toast = null;
            }, 2400);
        },
        removeItem(arr, i) {
            arr.splice(i, 1);
        },
        move(arr, i, delta) {
            const j = i + delta;
            if (j < 0 || j >= arr.length) return;
            const tmp = arr[j];
            arr.splice(j, 1, arr[i]);
            arr.splice(i, 1, tmp);
        },
        payload(forcePublish) {
            const f = this.form;
            return {
                id: f.id || 0,
                code: (f.code || '').trim(),
                title: f.title,
                subtitle: f.subtitle,
                nameText: f.nameText,
                summary: f.summary,
                tag: f.tag,
                theme: f.theme,
                verses: (f.verses || []).filter(v => v && v.trim()),
                verseFrom: f.verseFrom,
                paragraphs: (f.paragraphs || []).filter(p => p && p.trim()),
                sign: f.sign,
                signDate: f.signDate,
                date: f.date,
                status: forcePublish ? 1 : f.status,
                sort: f.sort || 0,
                remark: f.remark
            };
        },
        save(forcePublish) {
            if (this.saving) return;
            if (!this.form.title || !this.form.title.trim()) {
                this.notify('请先填写页面标题', 'err');
                return;
            }
            this.saving = true;
            adminApi
                .save(this.payload(forcePublish))
                .then(data => {
                    this.form.id = data.id;
                    if (forcePublish) this.form.status = 1;
                    if (!this.form.code && data.page && data.page.code) {
                        this.form.code = data.page.code;
                    }
                    this.savedAt = new Date().toTimeString().slice(0, 8);
                    this.notify(forcePublish ? '已保存并发布' : '已保存');
                })
                .catch(err => this.notify(err.message, 'err'))
                .finally(() => {
                    this.saving = false;
                });
        },
        preview() {
            this.$router.push({ path: '/admin/preview', query: { id: this.form.id } });
        },
        back() {
            this.$router.push('/admin/pages');
        }
    }
};
</script>

<style lang="less" scoped>
.edit-grid {
    display: flex;
    align-items: flex-start;
    gap: 18px;
}
.edit-main {
    flex: 1;
    min-width: 0;
}
.edit-side {
    width: 300px;
    flex: none;
    position: sticky;
    top: 18px;
}

.edit-form {
    padding: 20px 22px 24px;
}

.row-2 {
    display: flex;
    gap: 16px;
    > .a-form-row {
        flex: 1;
        min-width: 0;
    }
}
.row-3 {
    display: flex;
    gap: 16px;
    > .a-form-row {
        flex: 1;
        min-width: 0;
    }
}

.grow {
    flex: 1;
}
.save-hint {
    font-size: 12px;
    color: #1c7a4a;
}

/* 列表编辑器 */
.list-editor {
    .le-item {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        margin-bottom: 8px;
        .le-idx {
            flex: none;
            width: 22px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            font-size: 11.5px;
            color: #a89383;
        }
        .a-input {
            flex: 1;
            min-width: 0;
        }
        &.para .le-idx {
            height: auto;
        }
        &.para textarea.a-input {
            min-height: 68px;
        }
        .le-ops {
            display: flex;
            flex-direction: column;
            gap: 4px;
        }
    }
}

.edit-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 24px;
    padding-top: 18px;
    border-top: 1px solid #f0e6da;
}

/* 速览 */
.mini-preview {
    margin: 16px;
    padding: 20px 16px;
    border-radius: 10px;
    background: #fdf3e7;
    border: 1px solid #eadcc9;
    max-height: 520px;
    overflow: auto;
    text-align: center;
    .mp-name {
        font-size: 15px;
        letter-spacing: 6px;
        color: #a3122e;
        margin-bottom: 10px;
        font-weight: 600;
    }
    .mp-title {
        font-size: 15px;
        font-weight: 600;
        color: #5b4636;
        line-height: 1.6;
    }
    .mp-sub,
    .mp-date {
        margin-top: 6px;
        font-size: 11.5px;
        color: #b08d6e;
    }
    .mp-verse {
        margin-top: 10px;
        font-size: 13px;
        color: #8a2540;
        line-height: 1.9;
        font-family: 'STKaiti', 'KaiTi', serif;
    }
    .mp-para {
        margin-top: 12px;
        font-size: 12px;
        color: #4a3f35;
        line-height: 1.8;
        text-align: left;
        text-indent: 2em;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
    }
    .mp-sign {
        margin-top: 16px;
        font-size: 12px;
        color: #7a5c44;
        text-align: right;
    }
    .mp-count {
        margin-top: 14px;
        padding-top: 10px;
        border-top: 1px dashed #e0cdb6;
        font-size: 11px;
        color: #a89383;
    }

    /* 主题皮肤 */
    &.rose {
        background: linear-gradient(180deg, #4a0d1c 0%, #7b1030 100%);
        border-color: #7b1030;
        .mp-name,
        .mp-title {
            color: #ffe6ec;
        }
        .mp-sub,
        .mp-date,
        .mp-count {
            color: #e2a9b8;
        }
        .mp-verse {
            color: #ffd9e2;
        }
        .mp-para {
            color: #f6dde3;
        }
        .mp-sign {
            color: #ffc9d6;
        }
        .mp-count {
            border-top-color: rgba(255, 255, 255, 0.22);
        }
    }
    &.plain {
        background: #fff;
        border-color: #e6e6e6;
        .mp-title {
            color: #222;
        }
        .mp-para {
            color: #444;
        }
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
